var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-event" }, [
    _c(
      "div",
      {
        key: _vm.id,
        staticClass:
          "post card-status-border-color card-status-background-color hover-card-status-background-color hover-card-status-border-color",
        class: [_vm.status, { "is-placeholder": _vm.isPlaceholder }],
        on: { mousedown: _vm.handleMouseDown },
      },
      [
        _vm.image
          ? _c("div", { staticClass: "post-image", class: _vm.type }, [
              _c("img", { attrs: { src: _vm.image } }),
              _c("div", { staticClass: "type-post", class: _vm.type }),
            ])
          : _vm._e(),
        _c("div", { staticClass: "container-info" }, [
          _c("div", { staticClass: "top" }, [
            _c(
              "div",
              {
                staticClass: "badge-status",
                class: { loading: _vm.isLoading },
                attrs: { status: _vm.status },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.formatDate) +
                    "\n                "
                ),
              ]
            ),
            _vm.page
              ? _c(
                  "div",
                  { staticClass: "avatar", class: _vm.page.network },
                  [
                    _c("Tooltip", { attrs: { text: _vm.getPage.name } }, [
                      _c("img", {
                        attrs: { src: _vm.page.avatar || "img/avatar.jpg" },
                      }),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "content" }, [
            _c("p", [_vm._v(_vm._s(_vm.content))]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }